import CashierUpdateModal from "./cashier-update-modal";

export default CashierUpdateModal;
